import React from 'react';
import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';

/* eslint-disable react/prop-types, react/no-unstable-nested-components */
const WhsManagementGridActions = (permissions, settings, dispatchPush, navigateToWithholdingStatement, navigateToImyStructure) => ({
  id: 'action-column',
  Header: <span>Action</span>,
  Cell: ({ row }) => (
    <div>
      <div className="form-action-btn-group">
        { AccessControl.hasPermission(permissions, [ActivityPerms.scannedViewTree])
        && row.original.accountId
        && <button
          className="btn btn-sm"
          id={ 'btn-navToImy_'.concat(row.original.accountId) }
          type="button"
          title="Show IMY Tree Structure"
          onClick={ () => navigateToImyStructure(dispatchPush, row.original.accountId, row.original.version) }
        ><span className="icon icon-treeview" /></button> }
        { AccessControl.hasPermission(permissions, [ActivityPerms.multiTierMgrViewWhs])
        && (settings && settings.showMultiTierManager)
        && row.original.accountId
        && <button
          className="btn btn-sm icon-whd-stmt"
          id={ 'btn-navToWhs_'.concat(row.original.accountId) }
          type="button"
          title="View Digital Withholding Statement"
          onClick={ () => navigateToWithholdingStatement(dispatchPush, row.original.accountId, row.original.version) }
        >WHS</button> }
      </div>
    </div>
  ),
  className: 'col-6p5'
});

export default WhsManagementGridActions;
